const baseAddressMap = {
  //test
  // localhost: "https://rcstudio-core.datarete.cloud/",
  localhost: "https://rcstudio-core.datarete.cloud/",

  //live
  "rcstudio.datarete.cloud": "https://rcstudio.datarete.cloud/"
};

const themesMap = {
  localhost: "blue-theme",
  "rcstudio.datarete.cloud": "blue-theme"
};

const host = window.location.hostname;
const cleanedHost = host.replace(/[^a-z0-9._-]/gi, "").toLowerCase();

let baseAddress = null;
let theme = null;
if (cleanedHost) {
  baseAddress = baseAddressMap[host] || null;
  theme = themesMap[cleanedHost] || null;
}

const settingAddress = baseAddress + "api/GetSettings";
const apiAddress = baseAddress + "api/";
const driveAddress = baseAddress + "Drive/";

export { baseAddress, settingAddress, apiAddress, driveAddress, theme };
